import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Grid from '../Base/AntGrid';
import { fetchServer } from '../Base/modelManager';
import { message } from 'antd';
import moment from 'moment';
import { excelExport } from '../Base/ExportExcelAction';
import { Button, Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CarteEditor from './CarteEditor';
import {  FilterDropDown } from '../Base/Filters';
import FilterEnum from '../Base/FilterEnum';

class Cartes extends React.Component {
    constructor(props) {
        super(props)

        const actions = [
            {
                id: 'reload',
                icon: <img src="/assets/images/icons/picto_rafraichir.svg" alt="Bootstrap" width="20" height="20" className='gridHeaderImage'/>,
                libelle: 'Recharger',
                onExecute: () => {
                    this.handleFetch()
                }
            },
            excelExport(this.props.apiUrl + '/Services/exportCarte', 'Carte.xlsx', this.getFilterProcessed, () => '', this.getToken)
        ]


        this.state = {
            data: [],
            columns: [],
            loading: false,
            keyField: '',
            queryColumns: [],
            height: 0,
            quickFilterString: '',
            actions: actions,
            render: true,
            selectedRows: [],
            modal: {
                isOpen: false,
                view: null,
                record: null,
            },
            filters:{
                "badge": null,
                "typebadge": null,
                "status": [500,600]
              },
            pagination: {
                current: 1,
                total: 0,
                pageSize: 10,
            }


        }
    }

    getToken = () => {
        return this.props.JWTToken
    }


    getFilterProcessed = () => {
        const { filter } = this.state

        return this.processFilter(filter)
    }

    componentDidMount() {
        this.handleFetch()
    }

    componentDidUpdate(prevProp) {
        if (prevProp.currentClient !== this.props.currentClient)
            this.handleFetch()
    }

    closeModal = () => {
        this.setState({
            modal: {
                isOpen: false,
                view: null,
                record: null
            }
        })
        this.handleFetch()
    }

    getModalComponent = () => {
        const { modal } = this.state

        if (modal.isOpen) {
            return (
                <Modal show={modal.isOpen} >
                    <CarteEditor record={modal.record} onClose={() => this.closeModal()} />
                </Modal>
            )
        }
    }

    renderPlafond = (record, text) => {
        return (
            <>{record.plafondMensuel !== undefined && record.plafondMensuel !== '' && record.plafondMensuel !== null ? <>Men.:{record.plafondMensuel}</> : null}
                {record.plafondhebdo !== undefined && record.plafondhebdo !== '' && record.plafondhebdo !== null ? <>{record.plafondMensuel !== undefined && record.plafondMensuel !== '' && record.plafondMensuel !== null ? <br /> : null}Hebd.:{record.plafondhebdo}</> : null}
                {record.plafondQuot !== undefined && record.plafondQuot !== '' && record.plafondQuot !== null ? <>{(record.plafondMensuel !== undefined && record.plafondMensuel !== '' && record.plafondMensuel !== null) || (record.plafondhebdo !== undefined && record.plafondhebdo !== '' && record.plafondhebdo !== null) ? <><br />Quot.:</> : null}{record.plafondQuot}</> : null}</>
        )
    }



    columns = () => {
        const cols = []
        const {filters}=this.state


        cols.push(

            {
                width: 160,
                type: 'ftString',
                title: 'Numéro',
                dataIndex: 'numero',
                key: 'numero',
                filteredValue: filters.numero,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropDown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                        <Form.Control
                            
                            placeholder='numéro de carte contient'
                            value={selectedKeys}
                            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                            onPressEnter={() => confirm()}
                            style={{ marginBottom: 8, display: 'block' }}
                        />
                    </FilterDropDown>
                ),
                },
            {
                width: 90,
                type: 'ftString',
                title: 'Type',
                render: (text, record) => record.typeCarte ? record.typeCarte.libelle : null,
                key: 'typecarte',
                filteredValue: filters.typecarte,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropDown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                        <FilterEnum
                            datasource='/AbonnementCarte'
                            selected={selectedKeys}
                            onChange={(value) => { setSelectedKeys([...value]) }}
                            style={{ marginBottom: 8, display: 'block' }}
                            id='code'
                            libelle='libelle'
                        /><br />
                    </FilterDropDown>
                ),
                },
            {

                width: 200,
                type: 'ftString',
                title: <>Chauffeur<br />Immatriculation<br />Centre de Cout</>,
                render: (text, record) => <>{record.Chauffeur}<br/>{record.immatriculation}<br/>{record.department} </>,
                key: 'chauffeur'
            },

            {
                style: { paddingLeft: '2px', paddingRight: '0px' },
                width: '24px',
                className: 'ColCardProduct',
                title: <OverlayTrigger
                    style={{ paddingLeft: '0px', paddingRight: '0px' }}
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Gasoil</Tooltip>}
                >
                    <img className="gridHeaderImage" alt='' src="/assets/images/icons/picto_gasoil.svg" width="20" height="20" style={{ 'marginRight': '4px' }}/>
                </OverlayTrigger>,
                render: (text, record) => <Form.Check  defaultChecked={record.gasoil} size='small' />,

            },
            {
                style: { paddingLeft: '0px', paddingRight: '0px' },
                width: '24px',
                title: <OverlayTrigger
                    style={{ paddingLeft: '0px', paddingRight: '0px' }}
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Essence</Tooltip>}
                >
                 
                    <img className="gridHeaderImage" alt=''  src="/assets/images/icons/picto_essence.svg" width="20" height="20" style={{ 'marginRight': '4px' }} />
                </OverlayTrigger>,
                render: (text, record) => <Form.Check  defaultChecked={record.Essence} size='small' />,
            },            
            {
                style: { paddingLeft: '0px', paddingRight: '0px' },
                width: '24px',
                title: <OverlayTrigger
                    style={{ paddingLeft: '0px', paddingRight: '0px' }}
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Lubrifiant</Tooltip>}
                >
                    <img className="gridHeaderImage" alt=''src="/assets/images/icons/picto_huile.svg" width="20" height="20" style={{ 'marginRight': '4px' }} />
                </OverlayTrigger>,
                render: (text, record) => <Form.Check  defaultChecked={record.Lubrifiant} size='small' />,
            },
            {
                style: { paddingLeft: '0px', paddingRight: '0px' },
                width: '24px',
                type: 'ftString',
                title: <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Service Véhicule</Tooltip>}
                >
                    <img className="gridHeaderImage" alt='' src="/assets/images/icons/picto_reparation.svg" width="20" height="20" style={{ 'marginRight': '4px' }} />
                </OverlayTrigger>,
                render: (text, record)=> <Form.Check  defaultChecked={record.ServicesVehicule} size='small' />,
                key: 'ServicesVehicule'
            },
            {
                style: { paddingLeft: '0px', paddingRight: '0px' },
                width: '24px',
                type: 'ftString',
                title:
                    <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip>Lavage</Tooltip>}
                    >
                        <img className="gridHeaderImage" alt='' src="/assets/images/icons/picto_lavage.svg" width="20" height="20" style={{ 'marginRight': '4px' }} />
                    </OverlayTrigger>,
                render: (text, record) => <Form.Check  defaultChecked={record.lavage} size='small' />,
                key: 'lavage'
            },
          /*  {
                style: { paddingLeft: '0px', paddingRight: '0px' },
                width: '24px',
                type: 'ftString',
                name: <OverlayTrigger
                    className='Overlaycarte'
                    style={{ paddingLeft: '0px', paddingRight: '0px' }}
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Péage</Tooltip>}
                >
                    <img className="gridHeaderImage" alt='' src="/assets/images/peage01.jpg" style={{ 'marginRight': '4px' }} />
                </OverlayTrigger>,
                selector: (record) => <Form.Check.Input readOnly defaultChecked={record.peage} size='small' />,
                key: 'peage'
            },*/
            {
                style: { paddingLeft: '0px', paddingRight: '0px' },
                className: 'Carbcol',
                width: '24px',
                title: <OverlayTrigger
                    style={{ paddingLeft: '0px', paddingRight: '0px' }}
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Electrique</Tooltip>}
                >
                    <img className="gridHeaderImage" alt='' src="/assets/images/icons/picto_recharge_electrique.svg" width="20" height="20" style={{ 'marginRight': '4px' }} />
                </OverlayTrigger>,
                render: (text, record) => <Form.Check  defaultChecked={record.electrique} size='small' />,
            },
        )

        cols.push(
            {
                width: 90,
                type: 'ftDate',
                title: 'Mise en Service',
                render: (text, record) => record.dateMES !== null && moment(record.dateMES).format('L')!=='30/12/1899' ? moment(record.dateMES).format('L') : '',
                key: 'dateMES',
                },
            {

                width: 150,
                type: 'ftString',
                title: 'Statut',
                render: (text, record) => record.status !== null ? record.status.libelle : '',
                key: 'status',
                defaultFilteredValue:filters.status,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropDown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                        <FilterEnum
                            datasource='/statusCarte'
                            selected={selectedKeys}
                            onChange={(value) => { setSelectedKeys([...value]) }}
                            style={{ marginBottom: 8, display: 'block' }}
                            id='uid'
                            libelle='libelle'
                        /><br />
                    </FilterDropDown>
                ),
                },
            {
                width: 90,
                type: 'ftDate',
                title: 'Date Statut.',
                render: (text, record) => record.datestatus !== null && moment(record.datestatus).format('L')!=='30/12/1899' ? moment(record.datestatus).format('L') : '',
                key: 'dateStatus',
                },
            {
                width: 100,
                type: 'ftString',
                title: 'Plafond',
                render: (text, record) =>this.renderPlafond(record,text) ,
                key: 'plafondmensuel'
            },
            {
                width: 85,
                type: 'ftDate',
                title: 'Date Expir.',
                render: (text, record) => record.DateExpir !== null ? moment(record.DateExpir).format('L') : '',
                key: 'DateExpir',
                },
           /* {
                width: 80,
                type: 'ftString',
                name: 'type Vehi.',
                selector: record => record.TypeVehicule,
                key: 'typeVehicule'
            }*/
        )
        /*
        const actionsWidth = (1 * 30)
        cols.push({
            
            key: 'operation',
            dataIndex: 'operation',
            fixed: 'right',
            width: actionsWidth,
            render: (text,record) => this.actionRenderer(record),
        })
*/
        return cols

    }

    customStyles = {

        headCells: {
            style: {
                paddingLeft: '2px', // override the cell padding for head cells
                paddingRight: '2px',
            },
        },
        cells: {
            style: {
                paddingLeft: '2px', // override the cell padding for data cells
                paddingRight: '2px',
            },
        },
    };



    processFilter = (filter) => {


        let filterStr = ''

        if (filter !== undefined && filter !== null) {
            const filtersValue = Object.keys(filter);
            if (filtersValue.length > 0) {
                filtersValue.forEach(key => {
                    if (key === 'numero' && filter[key] !== null) {
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + 'contains(numero,\'' + filter[key] + '\')'
                    }
                    if (key === 'client' && filter[key] !== null) {
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + '(contains(client/numero,\'' + filter[key] + '\') or contains(client/nom,\'' + filter[key] + '\'))'
                    }
                    if (key === 'actif')
                        if (filter[key] !== null && filter[key][0] !== -1) {
                            if (filterStr !== '') filterStr = filterStr + ' and '
                            filterStr = filterStr + ' status/isActif eq ' + (filter[key][0] === 1 ? 'true' : 'false')
                        }
                    if (key === 'status' && filter[key] !== null && filter[key].length > 0) {
                        let str = ''
                        filter[key].forEach((value, index) => {
                            if (index > 0) str = str + ' or '
                            str = str + 'status/uid eq ' + value
                        })
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + '(' + str + ')'
                    }

                    if (key === 'fournisseur' && filter[key] !== null && filter[key].length > 0) {
                        let str = ''
                        filter[key].forEach((value, index) => {
                            if (index > 0) str = str + ' or '
                            str = str + 'fournisseur/code eq \'' + value + '\''
                        })
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + '(' + str + ')'
                    }
                    if (key === 'typecarte' && filter[key] !== null && filter[key].length > 0) {
                        let str = ''
                        filter[key].forEach((value, index) => {
                            if (index > 0) str = str + ' or '
                            str = str + 'typeCarte/code eq \'' + value + '\''
                        })
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + '(' + str + ')'
                    }
                })
            }


        }


        if (this.props.client !== undefined) {
            if (filterStr !== '') filterStr = filterStr + ' and '

            filterStr = filterStr + ' client/uid eq ' + this.props.client.uid
        }





        if (filterStr !== '')
            filterStr = '&$filter=' + filterStr




        return filterStr
    }

    onError = (error) => {
        message.error(error)
    }

    openModal = (action, data) => {
        this.setState(
            {
                modal: {
                    isOpen: true,
                    view: action,
                    record: data,
                }
            }
        )
    }

    actionRenderer = (record) => {


        const actions = []
        if (record.fournisseur.code==='WEX')
        actions.push(
            {
                id: 'edit',
                icon: <img className="gridHeaderImage" alt='' src="/assets/images/icons/pencil-square.svg" style={{ 'marginRight': '4px' }} />,
                tooltip: 'Modifier',
                onExecute: (event) => {
                    this.openModal('Edit', record)
                }
            })



        return (
            <span>
                {
                    actions.map((action) => {
                        const renderTooltip = (props) =>
                            <Tooltip id={props.id}>
                                {props.tooltip}
                            </Tooltip>

                        return (
                            <OverlayTrigger
                                key={action.id}
                                placement="right"
                                delay={{ show: 250, hide: 400 }}
                                overlay={renderTooltip(action)}
                            >

                                <Button bsPrefix="gridButton" onClick={(event) => { action.onExecute(event) }}> {action.icon}</Button>

                            </OverlayTrigger>

                        )
                    })
                }
            </span>

        )
    }

    handleFetch = (pagination, filters, sorter) => {



        if (this.state.loading === false) {
            this.setState({ loading: true })

            if (pagination === undefined)
                pagination = this.state.pagination
            else
                pagination = { ...this.state.pagination, ...pagination }

            if (filters === undefined)
                filters = this.state.filters

            if (sorter === undefined)
                sorter = this.state.sorter

            const filter = this.processFilter(filters)

            // filter.page = page;
            // filter.pageSize = this.state.pageSize

            const request = {
                endPoint: this.props.apiUrl + '/carte?$expand=typeCarte, status,fournisseur&$top=' + pagination.pageSize + '&$skip=' + pagination.pageSize * (pagination.current - 1) + '&$inlinecount=allpages' + filter,
                method: 'GET',
                token: this.props.JWTToken
            }

            fetchServer(request, (json) => {
                this.setState(({
                    loading: false,
                    data: json.value,
                    pagination: {
                        total: json['@xdata.count'],
                        current: pagination.current,
                        pageSize: pagination.pageSize
                    },
                    render: true,
                    filters: filters

                }))
            }, this.onError)

        }
    }

    render() {

        return (
            <>
                {this.getModalComponent()}
                <Grid
                    data={this.state.data}
                    columns={this.columns()}
                    pagination={this.state.pagination}
                    loading={this.state.loading}
                    keyField='id'
                    handleFetch={this.handleFetch}
                    actions={this.state.actions}
                    modes={this.state.modes}
                    title='- MES CARTES -'
             
                />
            </>
        )


    }
}


const mapStateToProps = (state) => {
    return ({
        serverConfigLoaded: state.server.initialized,
        clients: state.authentication.clients,
        currentClient: state.authentication.currentClient,
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
    })
}

Cartes.propTypes = {
    dispatch: PropTypes.func,
    clients: PropTypes.array,
    currentClient: PropTypes.object,
    apiUrl: PropTypes.string,
    JWTToken: PropTypes.string
};

export default connect(mapStateToProps)(Cartes);
